import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { environment } from "projects/htl-part/src/environments/environment";

@Component({
    selector: "app-picture-preview-dialog",
    templateUrl: "./picture-preview-dialog.component.html",
    styleUrls: ["./picture-preview-dialog.component.scss"],
    standalone: false,
})
export class PicturePreviewDialogComponent {
    title: string;
    imagePaths: string[] = [];

    constructor(
        public dialogRef: MatDialogRef<PicturePreviewDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: { title: string; pathArray: string[] },
    ) {
        this.title = this._data.title;
        this.imagePaths = this._data.pathArray;
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
